import { Link, useNavigate } from "react-router-dom";

import { faPlusCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Direction, Flex } from "@ntemarked/mittne-components/dist/Flex/Flex";

import { InfoColumn, InfoColumnValue, InfoRow } from "components/atoms/InfoRow";
import Error from "components/molecules/Error";
import Loading from "components/molecules/Loading";
import { MainLayoutPageHeader } from "components/organisms/MainLayout";
import { useGetGroupsQuery } from "pages/Features/Grupper/Groups.graphql-gen";

export default function GroupsPage() {
	const navigate = useNavigate();
	const { data, error, loading } = useGetGroupsQuery();

	return (
		<Flex direction={Direction.column} gap="calc( var(--grid-2) * 2)">
			<MainLayoutPageHeader
				title={
					<Flex gap="var(--grid-2)">
						Grupper
						<Link to="0/edit" title="Ny gruppe">
							<FontAwesomeIcon icon={faPlusCircle} />
						</Link>
					</Flex>
				}
				intro="Lag grupper med brukere, og slå av/på feature flags for gruppen. "
			/>
			<Flex style={{ borderRadius: "15px", overflow: "hidden" }} direction={Direction.column}>
				{error && !loading && <Error errorMessage="Feil ved henting av grupper" />}
				{loading && !data && <Loading />}
				{data?.groups?.map((group) => (
					<InfoRow
						key={group.id}
						interactive
						onClick={() => {
							navigate("/groups/" + group.id);
						}}
					>
						<InfoColumn width="25%">
							<InfoColumnValue>
								<b>{group?.displayName}</b> ({group?.usersCount} {group?.usersCount === 1 ? "bruker" : "brukere"})
							</InfoColumnValue>
						</InfoColumn>
					</InfoRow>
				))}
			</Flex>
		</Flex>
	);
}
